/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import { FC } from 'react'
import { PaymentMethod } from '../../core/_models'

type Props = {
  paymentmethod: PaymentMethod
}

const PaymentMethodInfoCell: FC<Props> = ({ paymentmethod }) => {
  return (
    <div className='d-flex align-items-center'>
      {/* begin:: Account Image */}
      <div className='me-3'>
        <a href='#'>
          {paymentmethod.account_image ? (
            <div className='symbol-label'>
              <img src={`${paymentmethod.account_image}`} alt={paymentmethod.method_name || 'Payment Method'} className='w-25' />
            </div>
          ) : (
            <div
              className={clsx(
                'symbol-label fs-3',
                'bg-light-primary', // Default background if image is not available
                'text-primary'      // Default text color if image is not available
              )}
            >
              {paymentmethod.method_name?.charAt(0).toUpperCase() || 'P'}
            </div>
          )}
        </a>
      </div>

      {/* begin:: Payment Method Name and Account Details */}
      {/* <div className='d-flex flex-column'>
        <a href='#' className='text-gray-800 text-hover-primary mb-1'>
          {paymentmethod.method_name || 'N/A'}
        </a>
        {paymentmethod.account_details && (
          <span className='text-muted'>
            {paymentmethod.account_details}
          </span>
        )}
      </div> */}
    </div>
  )
}

export { PaymentMethodInfoCell }
